/*
 * Model permissions
 */

export const modelPermissions = [
  // TODO: Cleanup next month
  // Other model permissions except commercialUses are removed on 2025-11-27

  // 'shareImagesOnline',
  // 'personalUses',
  'commercialUses',
  // 'shouldCreditAuthor',
] as const

export type ModelPermission = (typeof modelPermissions)[number]

/*
 * Model filters
 */

export const ALL_OPTION = { value: '', label: 'common:visibility.all' }

export const MODEL_USAGE_OPTIONS = [
  ALL_OPTION,
  { value: 'model', label: 'generation:model.label' },
  { value: 'lora', label: 'LoRA' },
]

export type MODEL_TYPE_OPTION_ALIAS = '' | 'sdv1' | 'sdxl' | 'dit7' | 'mmdit26a'

// Shared by both ModelTypes and BaseModelTypes
export const BASE_MODEL_TYPE_OPTIONS = [
  ALL_OPTION,
  { value: 'mmdit26a', label: 'DiT.2' },
  { value: 'dit7', label: 'DiT.1' },
  { value: 'sdxl', label: 'SDXL' },
  { value: 'sdv1', label: 'SD 1.5' },
] as { value: MODEL_TYPE_OPTION_ALIAS; label: string }[]

export const MODEL_SOURCE_OPTIONS = [
  ALL_OPTION,
  { value: 'pixai', label: 'PixAI' },
  { value: 'external', label: 'common:sources.external.label' },
]

// TODO: This could be global constant
export const TIME_RANGE_OPTIONS = [
  { value: '', label: 'market:search.all-time' },
  { value: 'today', label: 'market:search.today' },
  { value: 'this-week', label: 'market:search.this-week' },
  { value: 'this-month', label: 'market:search.this-month' },
]
